import { ReactCompareSlider } from "react-compare-slider";
import PannablePhoto from "./PannablePhoto";

// The photo stage for the two paired comparison modes — a draggable divider
// (slider) or a cross-dissolve (fade). Renders nothing for any other mode, so
// callers own the side-by-side layout themselves.
//
// `left` / `right` are { src, label }; `state` comes from usePairCompareState
// and is held by the caller so adjustments survive a mode switch.
const PairCompareStage = ({ mode, left, right, state }) => {
  const { getTransform, setTransform, fade, fadeSide } = state;

  if (mode === "slider") {
    return (
      <div className="compare-stage">
        <ReactCompareSlider
          className="compare-slider"
          onlyHandleDraggable
          itemOne={
            <PannablePhoto
              src={left.src}
              alt={left.label}
              transform={getTransform("left")}
              onChange={setTransform("left")}
            />
          }
          itemTwo={
            <PannablePhoto
              src={right.src}
              alt={right.label}
              transform={getTransform("right")}
              onChange={setTransform("right")}
            />
          }
        />
        <span className="stage-tag left">{left.label}</span>
        <span className="stage-tag right">{right.label}</span>
      </div>
    );
  }

  if (mode === "fade") {
    return (
      <div className="compare-stage">
        <PannablePhoto
          className="fade-base"
          src={right.src}
          alt={right.label}
          transform={getTransform("right")}
          onChange={setTransform("right")}
        />
        <PannablePhoto
          className="fade-overlay"
          src={left.src}
          alt={left.label}
          transform={getTransform("left")}
          onChange={setTransform("left")}
          style={{
            opacity: (100 - fade) / 100,
            // Only the selected photo captures drag/pinch/wheel; the other
            // lets the gestures fall through to the layer beneath.
            pointerEvents: fadeSide === "left" ? "auto" : "none",
          }}
        />
      </div>
    );
  }

  return null;
};

export default PairCompareStage;
